import { render, staticRenderFns } from "./DataListStateful.vue?vue&type=template&id=4abc87be&scoped=true"
import script from "./DataListStateful.vue?vue&type=script&lang=js"
export * from "./DataListStateful.vue?vue&type=script&lang=js"
import style0 from "./DataListStateful.vue?vue&type=style&index=0&id=4abc87be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc87be",
  null
  
)

export default component.exports